import BaseController from './basePlayerController';

export default class ControllerAutoPlayButton extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_AUTO_SPIN: 'auto_spin_button',
    };
    this._eEventTypes = {
      AUTO_SPIN_CLICK: this.getEventName(this._eButtonsTypes.EBT_AUTO_SPIN),
    };
    this._eElementsTypes = {
      EET_AUTO_SPIN_BUTTON: this._eButtonsTypes.EBT_AUTO_SPIN,
    };

    this.init(container);
  }

  toggleActive(value) {
    if (value) {
      this.interactiveElements[this._eElementsTypes.EET_AUTO_SPIN_BUTTON].classList.add('toggled_on');
    } else {
      this.interactiveElements[this._eElementsTypes.EET_AUTO_SPIN_BUTTON].classList.remove('toggled_on');
    }
  }

  _getMarkup() {
    return `<button id=${this.interactiveElementsIds[this._eElementsTypes.EET_AUTO_SPIN_BUTTON]} class="auto-play-button" data-color="primary">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M64.636 64.8091C59.3339 70.0698 52.0561 73.3392 43.9979 73.3392C27.7985 73.3392 14.6638 60.2044 14.6638 44.0051C14.6638 41.122 15.0968 38.3452 15.8694 35.7162" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.6035 22.9367C28.8823 17.8238 36.0693 14.6711 43.9978 14.6711C60.1972 14.6711 73.3319 27.8058 73.3319 44.0052C73.3319 46.8883 72.8989 49.6651 72.1263 52.2941" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M64.1641 44.337L73.3294 53.5023L82.4973 44.3344" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23.8316 43.6733L14.6663 34.5081L5.49846 43.6759" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M48.1711 51.032H39.7871L38.4431 55H32.7151L40.8431 32.536H47.1791L55.3071 55H49.5151L48.1711 51.032ZM46.7631 46.808L43.9791 38.584L41.2271 46.808H46.7631Z" fill="white"/>
          </svg>
        </button>`
  }
}
